import { Recurso } from "lib.common/dist/CleanArch";
import { ClienteTienda } from "../../bussines/entities/ClienteTienda";
import { ClientesTiendaDtSource } from "../../bussines/dataSources/ClientesTiendaDtSource";
import { apiDsTienda } from "src/config/keys";
import { transformacion } from "lib.common/dist";
import { ErrExterno } from "lib.common/dist/errorHandler";

export class ClientesTiendaDtSourceImplRest implements ClientesTiendaDtSource {
    async getAllClientesTienda(): Promise<Recurso<ClienteTienda[]>> {
        try {
            let url = transformacion.appendUrl(apiDsTienda, '/gestionPagos/cliente/all');
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },

            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de clientes en tienda.');
            }
            const { data } = await response.json();
            return Recurso.fromData<ClienteTienda[]>(data);

        } catch (error) {
            return Recurso.fromError<ClienteTienda[]>(new ErrExterno(error as Error));
        }
    }
}